import {
  GET_LABELS_REQUEST,
  GET_LABELS_SUCCESS,
  GET_LABELS_FAILURE,
  GET_LABELS_WITH_PAGINATION_REQUEST,
  GET_LABELS_WITH_PAGINATION_SUCCESS,
  GET_LABELS_WITH_PAGINATION_FAILURE,
  GET_PRINTERS_FOR_LABEL_REQUEST,
  GET_PRINTERS_FOR_LABEL_SUCCESS,
  GET_PRINTERS_FOR_LABEL_FAILURE,
} from "./labelCreationTypes";

const initialState = {
  loading: false,
  labels: [],
  error: "",
};

const getLabelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LABELS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LABELS_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_LABELS_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateWithPagination = {
  loading: false,
  labels: [],
  error: "",
};

const getLabelsWithPaginationReducer = (
  state = initialStateWithPagination,
  action
) => {
  switch (action.type) {
    case GET_LABELS_WITH_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_LABELS_WITH_PAGINATION_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_LABELS_WITH_PAGINATION_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPrinters = {
  loading: false,
  printers: [],
  error: "",
};

const getPrintersForLabelCreationReducer = (
  state = initialStateForPrinters,
  action
) => {
  switch (action.type) {
    case GET_PRINTERS_FOR_LABEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRINTERS_FOR_LABEL_SUCCESS:
      return {
        loading: false,
        printers: action.payload,
        error: "",
      };
    case GET_PRINTERS_FOR_LABEL_FAILURE:
      return {
        loading: false,
        printers: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export {
  getLabelsReducer,
  getLabelsWithPaginationReducer,
  getPrintersForLabelCreationReducer,
};
